import Request from "./request";

export default class ThirdPartyIntegration {
    static async updateConfigsZaloPayBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsZaloPayBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async updateConfigsBaoKimBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsBaoKimBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsBaoKimBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsBaoKimBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async getThirdPartyById(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/getIntegrationDetail',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async getConfigsTelegram(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/getStationIntegration',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async updateConfigsTelegram(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsTelegram',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async updateConfigsVMG(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsVMG',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async updateConfigsSmartGit(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsSmartGit',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async updateConfigsVietQR(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsVietQR',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async testConfigsTelegram(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsTelegram',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }
    static async testConfigsVMG(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsVMG',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }
    static async testConfigsSmartGift(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsSmartGift',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }
    static async testConfigsVietQR(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsVietQR',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }
    static async updateConfigsTingee(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsTingee',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsZaloPayBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsZaloPayBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async generateFlyerQRCode_DatLich(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/generateFlyerQRCode_DatLich',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async updateConfigsKimNganBusiness(data) {
            return new Promise((resolve, reject) => {
                Request.send({
                    method: 'POST',
                    path: '/ThirdPartyIntegration/advanceUser/updateConfigsKimNganBusiness',
                    data: { ...data },
                    query: null,
                }).then((result = {}) => {
                    const { statusCode, data } = result
                    if (statusCode === 200) {
                        return resolve(result)
                    } else {
                        reject(null)
                    }
                }).catch(err => {
                    reject(null)
                })
            })
        }

    static async testConfigsKimNganBusiness(data) {
            return new Promise((resolve, reject) => {
                Request.send({
                    method: 'POST',
                    path: '/ThirdPartyIntegration/advanceUser/testConfigsKimNganBusiness',
                    data: { ...data },
                    query: null,
                }).then((result = {}) => {
                    const { statusCode, data } = result
                    if (statusCode === 200) {
                        return resolve(data)
                    } else {
                        reject(result)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }

    static async updateConfigsShopeePay(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsShopeePay',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsShopeePay(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsShopeePay',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }

    static async updateConfigsGtelPayGateway(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsGtelPayGateway',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsGtelPayGateway(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsGtelPayGateway',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }

    static async updateConfigsVnpayBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsVnpayBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsVnpayBusiness(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsVnpayBusiness',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }

    static async updateConfigsVnpayInApp(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/updateConfigsVnpayInApp',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(result)
                } else {
                    reject(null)
                }
            }).catch(err =>{
                reject(null)
            })
        })
    }

    static async testConfigsVnpayInApp(data) {
        return new Promise((resolve,reject) => {
            Request.send({
                method: 'POST',
                path: '/ThirdPartyIntegration/advanceUser/testConfigsVnpayInApp',
                data: { ...data },
                query: null,
            }).then((result = {}) => {
                const { statusCode, data } = result
                if (statusCode === 200) {
                    return resolve(data)
                } else {
                    reject(result)
                }
            }).catch(err =>{
                reject(err)
            })
        })
    }

}
